import { Box } from '@chakra-ui/react'
import { type QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'

import { BoardNotFoundState } from '@/pages/board-page'

export interface MyRouterContext {
    queryClient: QueryClient
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
    component: Root,
    notFoundComponent: () => <BoardNotFoundState variant='invalid-link' />,
})

function Root() {
    return (
        <Box bg='custard.100' minH='100dvh' w='full'>
            <Outlet />
        </Box>
    )
}
